module.exports = __webpack_public_path__ + "static/img/feature_1.ee3cc05.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/hrdonates/feature_1.svg
// module id = ZzFR
// module chunks = 0